import { lazy } from 'react';

import { getAuthenticatorFromAuth } from 'utils/login-utils';
import {
  getSignInPropsFromKcContext,
  getOtpPropsFromKcContext,
  getScratchPropsFromKcContext,
  getPhoneActivatePropsFromKcContext,
} from 'app/props/kc-context-to-props';

import {
  getAndPresaveScratchProps,
} from 'app/props/presaved-props';

import {
  LOGIN_AUTHENTICATORS,
  OTP_AUTHENTICATORS,
  SCRATCH_AUTHENTICATORS,
} from 'consts/authenticators-constants';

import { NOT_POSSIBLE_OPERATION_TYPES } from 'web-ui-kit/dist/uni-credit-not-possible';
import { KcLoginContext, PasswordErrors } from 'types';

const AuthSignInPage = lazy(() => import('../pages/auth-sign-in-page'));
const AuthOtpPage = lazy(() => import('pages/auth-otp-page'));
const AuthPhoneActivatePage = lazy(() => import('pages/auth-phone-activate-page'));
const LostSessionPage = lazy(() => import('pages/lost-session-page'));
const AuthScratchCardPage = lazy(() => import('pages/auth-scratch-card-page'));
const AuthPermanentPasswordPage = lazy(() => import('pages/auth-permanent-password-page'));
const NotPossiblePage = lazy(() => import('pages/not-possible-page'));

export default function AppLoginFlow(kcContext: KcLoginContext) {
  const authenticator = getAuthenticatorFromAuth(kcContext.auth);

  switch (authenticator) {
    case LOGIN_AUTHENTICATORS.USERNAME_AND_PASSWORD:
    case LOGIN_AUTHENTICATORS.PHONE_AND_PASSWORD:
      return <AuthSignInPage
        {...getSignInPropsFromKcContext(kcContext)}
      />;

    case LOGIN_AUTHENTICATORS.PHONE_ACTIVATE:
      return <AuthPhoneActivatePage
        {...getPhoneActivatePropsFromKcContext(kcContext)}
      />;

    case OTP_AUTHENTICATORS.CONFIRM_SMS: {
      return <AuthOtpPage
        {...getOtpPropsFromKcContext(kcContext)}
        phoneActivation={kcContext.mobile_auth_consent}
      />;
    }

    case SCRATCH_AUTHENTICATORS.CONFIRM_SCRATCH:
      return <ScratchCardPageDependOnKeysCount
        {...kcContext}
      />;

    case LOGIN_AUTHENTICATORS.CHANGE_TEMP_PASSWORD:
      return <AuthPermanentPasswordPage />;

    case LOGIN_AUTHENTICATORS.LOST_SESSSION:
      return <LostSessionPage
        name={kcContext.name}
        error={kcContext?.message?.summary as PasswordErrors}
      />;

    default:
      throw new Error(`Login authenticator [${authenticator}] not found.`);
  }
}

function ScratchCardPageDependOnKeysCount(kcContext: KcLoginContext) {
  const availableKeysCount = parseInt(kcContext.tan_key_count);

  if (availableKeysCount <= 0) {
    return <NotPossiblePage
      reason={NOT_POSSIBLE_OPERATION_TYPES.AUTHORIZATION}
    />;
  }

  return <AuthScratchCardPage
    {...getScratchPropsFromKcContext(kcContext)}
    {...getAndPresaveScratchProps(kcContext)}
  />;
}
